export const images = {
  // logoOnly: logoOnly,
  errorImageIcon: '/assets/error-image.png',
  logo: '/assets/logo.webp',
  kakaotalkImage: '/assets/kakaotalk-logo.png',
  tableCareIcon: '/assets/icons/care.webp',
  tableCalendarIcon: '/assets/icons/calendar.webp',
  tableEyesIcon: '/assets/icons/eyes.webp',
  tableInquiryIcon: '/assets/icons/inquiry.webp',
  tableNoseIcon: '/assets/icons/nose.webp',
  tablePrepareIcon: '/assets/icons/prepare.webp',
  tableResurgeryIcon: '/assets/icons/resurgery.webp',
  tableSideEffectIcon: '/assets/icons/sideeffect.webp',
  tableSleepingIcon: '/assets/icons/sleeping.webp',
};

export const lottie = {
  search: '/assets/searching.json'
}


export const BLUR_URL =
  'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mN8//HLfwYiAOOoQvoqBABbWyZJf74GZgAAAABJRU5ErkJggg==';
